module.exports = __webpack_public_path__ + "static/media/WorkNest_Purple_Positive_RGB.7c5d0f97.svg";